import React from 'react';

interface Props {
  fieldUpdates: Record<string, any>;
  resolvedLabels: Record<string, string>;
}

const ExpenseEntryTable = ({ fieldUpdates, resolvedLabels }: Props) => {
  const accountIds = fieldUpdates['purchase_expense_entries.accounts.account_name'];
  const rates = fieldUpdates['purchase_expense_entries.rate'];
  const discountAmounts = fieldUpdates['purchase_expense_entries.discount_amount'];
  const taxAmounts = fieldUpdates['purchase_expense_entries.tax_amount'];
  const totalAmounts = fieldUpdates['purchase_expense_entries.total_amount'];

  if (!Array.isArray(accountIds) || accountIds.length === 0) return null;

  const rows = accountIds.map((_: any, i: number) => {
    const accountId = accountIds[i];
    const rate = parseFloat(rates?.[i]) || 0;
    const gross = rate;
    const discount = parseFloat(discountAmounts?.[i]) || 0;
    const tax = parseFloat(taxAmounts?.[i]) || 0;
    const total = parseFloat(totalAmounts?.[i]) || 0;
    const resolvedKey = `purchase_expense_entries.accounts.account_name:${accountId}`;
    const accountName = resolvedLabels[resolvedKey] || `Account #${accountId}`;
    return { accountName, rate, gross, discount, tax, total };
  });

  const subtotal = rows.reduce((sum, r) => sum + r.gross, 0);
  const totalDiscount = rows.reduce((sum, r) => sum + r.discount, 0);
  const totalTax = rows.reduce((sum, r) => sum + r.tax, 0);
  const totalDue = rows.reduce((sum, r) => sum + r.total, 0);

  return (
    <>
      <div style={{ overflowX: 'auto' }}>
        <div className="chatBot--preview-li" style={{ gridTemplateColumns: '1fr repeat(5, 85px)' }}>
          <div className="chatBot--preview-li-h">Account</div>
          <div className="chatBot--preview-li-h right">Rate</div>
          <div className="chatBot--preview-li-h right">Gross</div>
          <div className="chatBot--preview-li-h right">Discount</div>
          <div className="chatBot--preview-li-h right">Tax</div>
          <div className="chatBot--preview-li-h right">Total</div>
          {rows.map((r, i) => (
            <React.Fragment key={i}>
              <div className="chatBot--preview-li-c">{r.accountName}</div>
              <div className="chatBot--preview-li-c right">{r.rate.toFixed(2)}</div>
              <div className="chatBot--preview-li-c right">{r.gross.toFixed(2)}</div>
              <div className="chatBot--preview-li-c right">{r.discount.toFixed(2)}</div>
              <div className="chatBot--preview-li-c right">{r.tax.toFixed(2)}</div>
              <div className="chatBot--preview-li-c right">{r.total.toFixed(2)}</div>
            </React.Fragment>
          ))}
        </div>
      </div>
      <div className="chatBot--preview-tot">
        <div className="chatBot--preview-tot-row">
          <span>Subtotal</span>
          <span className="chatBot--preview-tot-row-val">{subtotal.toFixed(2)}</span>
        </div>
        {totalDiscount > 0 && (
          <div className="chatBot--preview-tot-row">
            <span>Discount</span>
            <span className="chatBot--preview-tot-row-val">-{totalDiscount.toFixed(2)}</span>
          </div>
        )}
        <div className="chatBot--preview-tot-row">
          <span>Total Tax</span>
          <span className="chatBot--preview-tot-row-val">{totalTax.toFixed(2)}</span>
        </div>
        <div className="chatBot--preview-tot-row total">
          <span>Total due (expenses)</span>
          <span className="chatBot--preview-tot-row-val">{totalDue.toFixed(2)}</span>
        </div>
      </div>
    </>
  );
};

export default ExpenseEntryTable;
